<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Grupos de permissões</h4>
          <router-link to="/app/permission">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div v-if="showItem">
          <el-select class=""
                      size="large"
                      filterable
                      placeholder="Digite para filtar"
                      v-model="compSelect">
            <el-option v-for="option in companyList"
                        class=""
                        :value="option.id"
                        :label="option.name"
                        :key="option.index">
            </el-option>
          </el-select>
        </div>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="dados">
            <el-table-column label="ID" property="id" width="180"></el-table-column>
            <el-table-column label="Nome" property="name" width="300"></el-table-column>
            <el-table-column label="Permissões" property="custom_permissions" min-width="360"></el-table-column>
            <el-table-column label="Ações" width="90">
              <div class="td-actions" slot-scope="props" >
                <a
                  class="btn btn-warning btn-link btn-xs" 
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </a>
                <a
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { selection } from 'd3';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select
  },
  data () {
    return {
      compSelect : '',
      dados: [],
      tabela: [],
      grade: [],
      companyList: [],
      showTable: true,
      showSelect: false
    }
  },
  mounted () {
    this.$store.dispatch("general/list").then(resp => {
      console.log('resp do come', resp)
      this.getListCompany()
      this.filtro()
    })
    this.$watch('compSelect', () => {
      this.$store.dispatch("general/list").then(() => {
        this.filtro()
    })
    })
  },
  computed: {
    showItem() {
      this.parentCompany = localStorage.getItem("parent_company")
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach == 'true') {
        return true
      } else if (localStorage.getItem("parent_company")) {
        return true
      } else {
        return false
      }
    },
  },
  created() {
  },
  methods: {
    filtro () {
      var x =  this.$store.state.general.groups
      this.tabela = []
      for (let index = 0; index < x.length; index++) {
        this.tabela[index] = x[index]
        for (let i = 0; i < this.tabela[index].custom_permissions.length; i++) {
          this.tabela[index].custom_permissions[i] = this.tabela[index].custom_permissions[i].description + ','+ ' '
        }
      }
      if (this.showItem) {
        this.grade = this.tabela.filter(v => {
          return v.company.id === Number(this.compSelect)
        })
      } else {
        this.grade = this.tabela.filter(v => {
          return v.company.id === Number(this.$store.state.auth.company)
        })
      }
      this.dados = this.grade
      this.dados.reverse()
      this.showTable = true
    },
    handleEdit(i, row) {
      this.$store.dispatch("general/get", {id: row.id }).then(() => {
      this.$router.push(`/app/permission/${row.id}`);
      });
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        console.log('companie as', resp)
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    handleDelete(i, row) {
      const itemName = "Grupo";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.showTable = false
          this.$store.dispatch("general/delete", { id: row.id }).then(() =>{
            this.dados = []
            swal.fire({
              title: "Pronto!",
              text: `${itemName} excluído(a).`,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            }).then(result =>{
              if (result.value) {
                // window.location.reload()
                this.$store.dispatch("general/list").then(()=>{
                  this.filtro()
                })
              }
            })
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
